module.exports = __webpack_public_path__ + "img/dog_face_2.9f9a150.svg";